// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__3bgDK","choiceBoxes":"toolbarselects_choiceBoxes__VvePb","simpleField":"toolbarselects_simpleField__mDuBv"};